import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SAVE, DISCARD } from '../../../static/keyWords.js';
import { messageManager } from '../../System/messageManager/messageManager.js';
import { Context } from '../../../store/Store.js';
import ForgeDialogWrapper from '../ForgeDialogWrapper/ForgeDialogWrapper.js';
import { ToastComponent } from '@tylertech/forge';
import { REDUCER_ACTION_TYPES } from '../../../store/Reducer.js';
import './UnsavedChangesDialog.scss';
import { useUser } from '../../../contexts/userContext.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';

const UnsavedChangesDialog = () => {
  const [state, dispatch] = useContext(Context);
  const [open, setOpen] = useState(false);
  const { user } = useUser();
  const { nameConventions } = useNameConventions();

  window.onbeforeunload = function () {
    if ((state.fireUnsavedChangesDialog || state.changesWereMade) && !state.download) {
      setOpen(true);
      return false;
    }
  };

  useEffect(() => {
    if ((state.fireUnsavedChangesDialog || state.changesWereMade) && !state.download) {
      setOpen(true);
      dispatch({ type: REDUCER_ACTION_TYPES.SET_USER_NAVIGATED, payload: false });
      dispatch({ type: REDUCER_ACTION_TYPES.FIRE_UNSAVED_CHANGES_DIALOG, payload: false });
    }
  }, [state.userNavigated]);

  const save = () => {
    dispatch({ type: REDUCER_ACTION_TYPES.SAVE_UNSAVED_CHANGES, payload: true });
    dispatch({ type: REDUCER_ACTION_TYPES.FIRE_UNSAVED_CHANGES_DIALOG, payload: false });
    dispatch({ type: REDUCER_ACTION_TYPES.SET_USER_NAVIGATED, payload: false });
    setOpen(false);
  };
  const discard = () => {
    dispatch({ type: REDUCER_ACTION_TYPES.DISCARD_UNSAVED_CHANGES, payload: true });
    dispatch({ type: REDUCER_ACTION_TYPES.FIRE_UNSAVED_CHANGES_DIALOG, payload: false });
    dispatch({ type: REDUCER_ACTION_TYPES.SET_USER_NAVIGATED, payload: false });
    dispatch({ type: REDUCER_ACTION_TYPES.SET_DISABLED_UNSAVED_CHANGES_DIALOG_SAVE_BUTTON, payload: false });
    setOpen(false);
  };

  const handleDiscardDueToViewOnly = () => {
    discard();
    ToastComponent.present({
      message: messageManager(nameConventions).SAVE_CHANGES_RESTRICTED_BECAUSE_USER_IS_VIEW_ONLY,
    });
  };

  return (
    <>
      {open &&
        <ForgeDialogWrapper
          title={messageManager(nameConventions).UNSAVED_CHANGES_DIALOG_TITLE}
          open={true}
          primaryButtonText={SAVE}
          secondaryButtonText={`${DISCARD} changes`}
          handleClickPrimaryButton={() => user?.isViewOnly ? handleDiscardDueToViewOnly() : save()}
          handleClickSecondaryButton={() => discard()}
          handleClose={() => discard()}
          interactionNeeded={false}
          initiallyNotDisabled={true}
          noDivider={true}
          classes="unsaved-changes-dialog"
        >
          <p className="noMargin">{messageManager(nameConventions).UNSAVED_CHANGES_DIALOG_MESSAGE}</p>
        </ForgeDialogWrapper>
      }
    </>
  );
};

UnsavedChangesDialog.propTypes = {
  open: PropTypes.bool,
  discard: PropTypes.func,
  save: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default UnsavedChangesDialog;
